import React from 'react';
import PropTypes from 'prop-types';
import {NavLink} from 'react-router-dom';

import StyledBreadcrumb from './StyledBreadcrumb';
import MotifBreadcrumbItem from '@ey/motif-react-wrapper/BreadcrumbItem';

const Breadcrumb = ({items = null}) => {
	if (!items) return false;

	const renderItem = ({id, label, url = null}) => {
		const props = {
			key: id,
			title: label
		};

		return (
			<MotifBreadcrumbItem {...props}>
				{url && <NavLink to={url}>{label}</NavLink>}
				{!url && <span>{label}</span>}
			</MotifBreadcrumbItem>
		);
	};

	return <StyledBreadcrumb>{items.map(renderItem)}</StyledBreadcrumb>;
};

Breadcrumb.propTypes = {
	items: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string,
			label: PropTypes.string,
			url: PropTypes.string
		})
	)
};

export default Breadcrumb;
